/**
 * The fields of a fetched customer that can be sent back on a PUT.
 *
 * The response carries the address collection as `addresses`. The backend
 * treats a sent `addresses` as the whole collection and ignores `address`,
 * so echoing the fetched copy would overwrite any change made through
 * `address` with stale data. Until the dashboard manages the collection
 * itself, it never sends it.
 */
export const toCustomerUpdateBody = <T extends object>(
  customer: T
): Omit<T, 'addresses'> => {
  const { addresses: _addresses, ...body } = customer as T & {
    addresses?: unknown
  }
  return body
}
